import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { ClientCsScoreHistoryModal } from '@/types/modal';
import { NoFooterModal } from '@/components/molecules/common/Modal';
import Table from '@/components/molecules/common/Table';
import { transformDateStringFrance } from '@/utilities/datetime';

const View: React.FC<{ modal: ClientCsScoreHistoryModal }> = ({ modal }) => {
  const { t } = useTranslation();

  const { client, onClose } = modal;
  const csScoreHistory = client.csScoreV2History || [];

  const getScoreColor = (score: number) => {
    if ([4, 5].includes(score)) {
      return '#ff5555';
    }

    return '#666666';
  };

  const columns: GridColDef[] = [
    {
      field: 'csScoreV2',
      headerName: t('client.basic_info.cs_score'),
      width: 150,
      renderCell: (params) => (
        <div style={{ color: getScoreColor(params.value), fontWeight: 'bold' }}>{params.value}</div>
      ),
    },
    {
      field: 'datetimeCalculated',
      headerName: t('modal.client_cs_score_history.date_calculated'),
      width: 200,
    },
  ];

  const rows = csScoreHistory.map((item, index) => {
    const formattedDate = transformDateStringFrance(item.datetimeCalculated);
    return {
      id: index,
      csScoreV2: item.csScoreV2,
      datetimeCalculated: formattedDate || item.datetimeCalculated,
    };
  });

  const body = (
    <Table
      rows={rows}
      columns={columns}
      loading={false}
      table={{
        kind: 'Table',
      }}
    />
  );

  return (
    <NoFooterModal
      title={t('modal.client_cs_score_history.title')}
      onClose={onClose}
      body={body}
      modalName="client_cs_score_history"
      containerStyle={{ width: 600, maxWidth: '90vw' }}
    />
  );
};

export default View;
